// extracted by mini-css-extract-plugin
export default {"modelRangeTab":"Xf2sAL0c1F","tabActive":"EvZLEXXIwZ"};